
import ContentIcon from "../ContentIcon";
import { ScoringToolContainer, StarListScore, StarFunction, StarReference } from "./styles";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import SaveCollectionsNews from "@/shared/SaveCollectionsNews";

const ScoringTool = (props) => {


  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};

  const starslist = [];
  const rating = 3;
  for (let i = 0; i < 5; i++) {
    starslist.push(
      <span className="star-icon" key={i}><ContentIcon width="34px" height="34px" nameIcon="star"></ContentIcon></span>
    );
  }

  const noteDetail = {
    _id: formatContent?._id,
    url: formatContent?.url
  };

  const countingStar = (num) => {
    const starsRef = [];
    for (let i = 1; i <= num; i++) {
      starsRef.push(
        <span key={i}>
          <ContentIcon width="12px" height="12px" nameIcon="star" />
        </span>
      );
    }
    return starsRef;
  };

  const closeScore = () => {
    const scoreModal = document.getElementById("scoringTool");
    const scoreTool = document.getElementById("score");
    scoreModal.style.display = "none";
    scoreTool.classList.remove("open");
  }
  return (
    <ScoringToolContainer id="scoringTool">
      <button className="btn-close" type="button" onClick={closeScore}>
        <ContentIcon width="18px" height="18px" nameIcon='closeIco' />
      </button>
      <StarFunction>
        <p>Marcá las estrellas</p>
        <StarListScore>
          {starslist}
        </StarListScore>
        <button>OK</button>
      </StarFunction>
      <div className="contentBottom">
        <span className="title">Puntuación</span>
        <StarReference>
          <div className="star-ref">
            <p>No lo pude comer</p>
            <div className="star-amount">{countingStar("1")}</div>
          </div>
          <div className="star-ref">
            <p>No me gustó</p>
            <div className="star-amount">{countingStar("2")}</div>
          </div>
          <div className="star-ref">
            <p>Podría mejorar</p>
            <div className="star-amount">{countingStar("3")}</div>
          </div>
          <div className="star-ref">
            <p>Me gustó</p>
            <div className="star-amount">{countingStar("4")}</div>
          </div>
          <div className="star-ref">
            <p>Me encantó</p>
            <div className="star-amount">{countingStar("5")}</div>
          </div>
        </StarReference>
      </div>
    </ScoringToolContainer>
  );
};

export default ScoringTool;